// Apolo IDE — Ghost text toggle (Sprint v11 P2 — second pass).
//
// Compact toggle for the Tab autocomplete (E5). Persists state to the same
// localStorage key the editor reads (`apolo:editor:inline-completion`) so
// the next focus/blur cycle picks up the new value without a rebuild.

import { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';

const LS_KEY = 'apolo:editor:inline-completion';

function readEnabled() {
  if (typeof window === 'undefined' || !window.localStorage) return false;
  try {
    return window.localStorage.getItem(LS_KEY) === 'true';
  } catch {
    return false;
  }
}

function writeEnabled(v) {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(LS_KEY, v ? 'true' : 'false');
  } catch {
    // ignore
  }
}

export default function GhostToggle() {
  const [enabled, setEnabled] = useState(() => readEnabled());

  useEffect(() => {
    function onStorage(e) {
      if (e?.key === LS_KEY) setEnabled(readEnabled());
    }
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const toggle = () => {
    setEnabled((v) => {
      const next = !v;
      writeEnabled(next);
      return next;
    });
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={enabled}
      title={enabled ? 'Ghost text ligado (Tab aceita) — clique pra desligar' : 'Ghost text desligado — clique pra ligar'}
      className={`inline-flex h-7 items-center gap-1 rounded-md border px-2 text-[11px] transition ${
        enabled
          ? 'border-apolo-accent/40 bg-apolo-accentMuted text-apolo-accent'
          : 'border-apolo-borderSubtle text-apolo-textTertiary hover:border-apolo-borderStrong hover:text-apolo-textPrimary'
      }`}
    >
      <Sparkles size={10} aria-hidden="true" />
      Ghost {enabled ? 'on' : 'off'}
    </button>
  );
}
